import { ChangeEvent } from 'react'

export function upload(proxy: ChangeEvent<HTMLInputElement>, uploadFile: (file: File) => void) {
  const { files } = proxy.target
  // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
  if (files.length > 0) {
    // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
    const file = files[0]
    uploadFile(file)
  }
}
